
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { mySettingsMenu } from '@xt/client/dataSource/my/index'
import { EnumMySettingsMenu } from '@xt/client/enums/my'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'
import MyLayout from '../views/MyLayout/index.vue'

import MySettingsMyself from './views/Myself/index.vue'
import MySettingsNotice from './views/Notice/index.vue'
import MySettingsAccount from './views/Account/index.vue'

import type { UserInfo } from '@xt/client/entities/user/types'

@Observer
@Component({
  scrollToTop: true,
  components: {
    MyLayout,
    MySettingsMyself,
    MySettingsNotice,
    MySettingsAccount
  },
  async asyncData(ctx) {
    // 没有token 用户没登录
    if (!ctx.store.$storeUser.isLogin) {
      ctx.redirect('/')
      return { userInfo: null }
    }

    const userInfo: UserInfo | undefined = ctx.store.$storeUser.UserInfo || (await ctx.store.$storeUser.onUpdatingUserInfo())

    if (!userInfo) {
      // 异常
      ctx.redirect('/')
      return { userInfo: null }
    }

    // 获取收货地址 - 用于个人资料收货地址刷新
    ctx.store.$storeUser.onRefreshUserAddress()

    return {
      userInfo
    }
  }
})
export default class MySettingsPage extends Vue {
  userInfo: UserInfo | null

  current: EnumMySettingsMenu = EnumMySettingsMenu.Myself

  compMap: Record<EnumMySettingsMenu, string> = {
    [EnumMySettingsMenu.Myself]: 'MySettingsMyself',
    [EnumMySettingsMenu.Notice]: 'MySettingsNotice',
    [EnumMySettingsMenu.Account]: 'MySettingsAccount'
  }

  get menuKey() {
    return lodash.get(this.$route.query, 'menu', EnumMySettingsMenu.Myself)
  }

  get menus() {
    return mySettingsMenu
  }

  get PageStore() {
    return this.$store.$myV2.Settings
  }

  handleChangeMenu(menu: EnumMySettingsMenu) {
    this.current = menu

    this.$router.replace({
      query: {
        menu: menu
      }
    })

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {
    this.current = this.menuKey as EnumMySettingsMenu
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
